import ValidatingForm from './ValidatingForm';


export default ValidatingForm;
